import InclusionDetailsLoadFull from '../components/InclusionDetailsLoadFull';
import Modal from '../components/Modal';
import Panels from '../components/Panels';
import StickyNav from '../components/StickyNav';

document.addEventListener('DOMContentLoaded', () => {
  //sticky nav init
  const stickyNav = StickyNav();
  stickyNav.init();

  Panels('js-bath-panels');
  InclusionDetailsLoadFull('js-kitchen-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-primary-bath-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-powder-room-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-secondary-bath-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-wholehome-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-exterior-inclusions', true, () => {
    stickyNav.refresh();
  });
  InclusionDetailsLoadFull('js-energy-inclusions');

  const downloadModal = Modal('js-download-modal');
  const downloadModalBtns = document.querySelectorAll('.js-btn-downloads');
  downloadModalBtns.forEach(downloadModalBtn => {
    downloadModalBtn.addEventListener('click', event => {
      event.preventDefault();
      downloadModal.open();
    });
  });
});
